import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";
import { Regex } from "../../types/Regex";

@Component({
  selector: "app-prefix-eml",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-eml.component.html",
  styleUrl: "./prefix-eml.component.less",
})
export class PrefixEmlComponent extends PrefixTextComponent {
  public maxlength: MaxLength;
  public regex: Regex;

  public constructor() {
    super();
    this.maxlength = 384;
    this.regex = "EMAIL";
    this.characters = ALLOWED_CHARACTERS["eml"];
  }
}
